<template>
  <div class="bhelp">
    <div class="content">
      <van-cell v-for="cell in resource" :key="cell.id" :title="cell.title" is-link :to="`/recommend/${cell.id}`" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { List, PullRefresh, Cell, CellGroup } from 'vant';
import { resource } from './resource';

Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Cell);
Vue.use(CellGroup);

export default {
  name: 'RecommendCenter',
  metaInfo: {
    title: '协议中心',
  },
  data() {
    return {
      resource,
    };
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.bhelp {
  background: rgba(243, 243, 243, 1);
  min-height: 100vh;
  padding-top: 16px;
}
.content {
  position: relative;
  padding: 0 16px;
  background: #fff;
  color: rgba(51, 51, 51, 1);
  .title {
    font-weight: 500;
    font-size: 16px;
  }
  /deep/.van-cell {
    padding: 12px 0;
  }
  /deep/.van-cell:not(:last-child)::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}
</style>
